module.exports = __webpack_public_path__ + "static/media/case-red.c7cc6f00.png";